import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import 'sanitize.css/sanitize.css';

import { store } from './app/store';

import './game/control';
import { subscribeRecord } from './unit';

import App from './app/App';

import { Analytics } from '@vercel/analytics/react';

subscribeRecord(store);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
    <Analytics />
  </Provider>
);
